import styled from '@emotion/styled';
import theme from '@travelnest/merlin.theme';

export const StyledRadio = styled.div<{ top?: number, left?: number }>`
	cursor: pointer;
	.merlin-radio__container {
		display: flex;
		align-items: center;
		position: relative;
	}
	/* Hide default radio button but allow for tab selection */
	.merlin-radio__input {
		z-index: -1;
		position: absolute;
		left: 2px;
	}
	/*
		This radio__button selector only handles the outline of the
		button, the radio__button:before is the thicker inner border
	*/
	.merlin-radio__button {
		flex: none;
		margin-right: 10px;
		position: relative;
		box-sizing: border-box;
		background: white;
		border: 1px solid ${theme.colours.neutral.medium};
		width: 45px;
		height: 45px;
		border-radius: 50%;
		transition: border 0.2s;
	}
	.merlin-radio__button:hover {
		cursor: pointer;
		border: 1px solid ${theme.colours.neutral.dark};
	}
	/*
		Checked and focus behaviour.  Focus changes the outline colour
		and checked has a wide inner border.  Note the outline is
		widened when checked & focussed to blend the two borders better
	*/
	.merlin-radio__input:checked + .merlin-radio__button:before {
		content: '\\e908';
		font-family: ${theme.typography.fonts.icons};
		font-weight: 800;
		color: ${theme.colours.neutral.darker};

		font-size: 2rem;
		display:inline-block;
		transform: translate(32%, 30%);
		width: 16px;
		height: 16px;
	}
	.merlin-radio__input:focus + .merlin-radio__button:after {
		width: 49px;
		height: 49px;
		border-radius: 50%;
		border: 1px solid ${theme.colours.highlight.default};
		position: absolute;
		content: "";
		top: ${(props) => props.top ? `${props.top}px` : '-3px'};
		left: ${(props) => props.left ? `${props.left}px` : '-3px'};
	}
	.merlin-radio__label {
		cursor: pointer;
	}
`;
